import { FormHelperText, FormHelperTextProps, makeStyles } from "@material-ui/core";
import * as React from "react";

const useStyles = makeStyles({
  root: { display: "flex", alignItems: "flex-start", gap: 4, marginTop: 4 },
  icon: { display: "block", marginTop: 2, flexShrink: 0 },
});

export const FormErrorText: React.FC<FormHelperTextProps> = ({ children, className, ...props }) => {
  const classes = useStyles();
  return (
    <FormHelperText {...props} error data-form-error className={`${classes.root} ${className ?? ""}`}>
      <img src="/icons/ds-v2-error-inline.svg" className={classes.icon} alt="" aria-hidden="true" />
      <span>{children}</span>
    </FormHelperText>
  );
};
